import store from '@/store'

const hasPermission = val => {
  const permissionList = store.getters.permission
  return permissionList[val]
}

export default (Vue) => {
  Vue.directive('auth', {
    inserted: (el, { value }) => {
      if (!hasPermission(value)) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  })
}
